import API_BASE_URL from '../Config';

export const getNacionalidades = async (token) => {
    const response = await fetch(`${API_BASE_URL}/nacionalidades`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar nacionalidades');
    return response.json();
};

export const getNacionalidadesPaginadas = async (token, page = 0, size = 10, search = '') => {
    const url = new URL(`${API_BASE_URL}/nacionalidades/page`);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (search) url.searchParams.append('search', search);

    const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar nacionalidades paginadas');
    return response.json();
};

export const getNacionalidadById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/nacionalidades/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar la nacionalidad');
    return response.json();
};

export const createNacionalidad = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/nacionalidades`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear la nacionalidad');
    return response.json();
};

export const updateNacionalidad = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/nacionalidades/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar la nacionalidad');
    return response.json();
};

export const darDeBajaNacionalidad = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/nacionalidades/${id}/dar-baja`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al dar de baja la nacionalidad');
};

export const deleteNacionalidad = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/nacionalidades/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar la nacionalidad');
};
